import { Chip as MuiChip, chipClasses, styled } from "@mui/material";
import React from "react";
import { path } from "ramda";

const StyledChipPropsToForward = ["backgroundColorPath", "textColorPath", "borderColorPath", "isRounded"];

const StyledChip = styled(MuiChip, {
  shouldForwardProp: (prop) => !StyledChipPropsToForward.includes(prop)
})(({ theme, backgroundColorPath, textColorPath, borderColorPath, isRounded }) => ({
  backgroundColor: backgroundColorPath
    ? path(["palette", ...backgroundColorPath], theme)
    : "transparent",
  color: textColorPath ? path(["palette", ...textColorPath], theme) : "black",
  border: borderColorPath ? `1px solid ${path(["palette", ...borderColorPath], theme)}` : "none",
  borderRadius: isRounded ? "100vmax" : "8px",
  fontSize: "12px",
  pointerEvents: "none",
  height: "26px",
  [`& .${chipClasses.label}`]: {
    padding: "6px 12px"
  }
}));

const Chip = ({
  backgroundColorPath,
  textColorPath,
  borderColorPath,
  isRounded = false,
  ...props
}) => (
  <StyledChip
    backgroundColorPath={backgroundColorPath}
    textColorPath={textColorPath}
    borderColorPath={borderColorPath}
    isRounded={isRounded}
    {...props}
  />
);

export default Chip;
